import FormInputBooleanCheckbox from "@repo/components/src/forms/booleanCheckbox";
import { Text } from "@repo/components/src/ui/text";
import { VStack } from "@repo/components/src/ui/vstack";
import { ComponentProps } from "react";

import type { TaxProfileFormState } from "./useTaxProfileForm";
import type { BooleanFormName, TaxProfileFieldData } from "./types";

type Props = {
  field: TaxProfileFieldData;
  name: BooleanFormName;
  form: TaxProfileFormState;
  size: ComponentProps<typeof FormInputBooleanCheckbox>["size"];
};

export default function BooleanField({ field, name, form, size }: Props) {
  return (
    <VStack space="xs">
      <FormInputBooleanCheckbox
        control={form.formProps.control}
        name={name}
        size={size}
        description={field.label}
      />
      {field.helpText ? (
        <Text size="xs" className="text-typography-600">
          {field.helpText}
        </Text>
      ) : null}
    </VStack>
  );
}
